import React from "react";
import { useTranslation } from "react-i18next";
import BaseModal from "@reusables/Modals/BaseModal";
import UIButton from "@reusables/UIButton";

interface ReservationsDisablingModalProps {
    isOpen: boolean;
    /**
     * "reservations" - all active reservations of the company are cancelled;
     * "locations" - per-location reservations keep their quantities, but become global reservations.
     */
    variant: "reservations" | "locations";
    isLoading: boolean;
    onClose: () => void;
    onConfirm: () => void;
}

/**
 * Confirmation shown before saving defaults that rewrite reservations which already exist.
 */
export default function ReservationsDisablingModal({
    isOpen,
    variant,
    isLoading,
    onClose,
    onConfirm,
}: ReservationsDisablingModalProps) {
    const { t } = useTranslation("", { keyPrefix: "settings.general.defaults.modals.disabling" });

    return (
        <BaseModal
            isOpen={isOpen}
            onClose={onClose}
            width={700}
            padding="56px"
            isLoading={isLoading}
        >
            <div className="space-y-[32px]">
                <div className="text-xl font-semibold text-center text-accent">
                    {t(`${variant}.heading`)}
                </div>
                <div className="text-center text-accent">{t(`${variant}.description`)}</div>
                <div className="grid grid-cols-2 gap-[16px]">
                    <UIButton size={"lg"} variant={"outline"} onClick={onClose}>
                        {t("buttons.cancel")}
                    </UIButton>
                    <UIButton size={"lg"} onClick={onConfirm} loading={isLoading}>
                        {t("buttons.confirm")}
                    </UIButton>
                </div>
            </div>
        </BaseModal>
    );
}
